export const routeMap: Record<string, string> = {
  // Admin routes
  "/admin": "Home",
  "/admin/employees": "Employees",
  "/admin/stores": "Stores",
  "/admin/more": "More",
  
  // Manager routes
  "/manager": "Home",
  "/manager/employees": "Employees",
  "/manager/items": "Items",
  "/manager/more": "More",
  
  // Cashier routes
  "/cashier": "Home",
  "/cashier/items": "Items",
  "/cashier/customers": "Customers",
  "/cashier/more": "More",

  // General
  "/subscription": "My Subscription",
  "/notifications": "Notifications",
  "/history/sales": "Sales History",
  "/history/products": "Product Records",
  "/settings": "Settings",
};
